export const LIVE_PAGE_ID = [
  '361231620965547',
  '394274810994296',
  '582769212229333',
  '998122266996445',
  '367229174088451',
  '746554075685318',
  '104798401281089',
  '1396503507148739',
  '1589840171084621',
  '100590148401358',
  '102564098201451',
  '105286034592205',
  '106043044515474',
  '106368351149754',
  '107704437498029',
  '101697018243932',
  '103787708076884',
  '100652118659247'
]



// WEBPACK FOOTER //
// ./src/constants/live.js